import React from 'react';
import c from 'classnames';
import s from './SpreadLayout.scss';
/** A purely layout focused component that spreads `left` and `right` props horizontally via `justify-content: space-between` */
var SpreadLayout = function (_a) {
    var left = _a.left, right = _a.right, className = _a.className;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement("div", { className: s['left'] }, left),
        React.createElement("div", { className: s['right'] }, right)));
};
SpreadLayout.displayName = 'SpreadLayout';
export default SpreadLayout;
//# sourceMappingURL=SpreadLayout.js.map